import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {Password} from '~/pages/old-onboarding/model/Password';

export function AllowedSymbolsDialog() {
    return (
        <RsnDialog.Window placement='center'>
            <RsnDialog.CenteredHeader>Allowed symbols</RsnDialog.CenteredHeader>
            <RsnDialog.Body>{Password.allowedSymbols.join(' ')}</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent='secondary' as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
